import { useGetCreditsBySite } from 'api/resource';
import { useCombineStates } from 'hooks/useCombineStates';
import { useCurrentSiteStore } from 'store/SiteStore';

export const useUserCreditManagementData = () => {
  const { id: siteID } = useCurrentSiteStore();
  const creditsResult = useGetCreditsBySite({ siteID });

  const { isLoading, isError, isFetching, errorMessage } = useCombineStates([
    creditsResult,
  ]);

  return {
    credits: creditsResult.data || [],
    isLoading,
    isError,
    isFetching,
    errorMessage,
  };
};
